import { extend } from '@thd-nucleus/data-sources';

import { AddItemsToCartDataModel } from './AddItemsToCartDataModel';
import { PromoListDataModel } from './PromoListDataModel';

export const PromoList1DrawerDataModel = extend(
  AddItemsToCartDataModel,
  PromoListDataModel,
);
